export { AccordionItemHeading } from './AccordionItemHeading.component';
